/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import axios from 'axios';
import api from './api.services';
import {showMessage} from "../_actions/message.actions";

export const getOverridePrice = (collectionId) => dispatch =>{
    return axios.get(api.get_override_price.replace('{collection-id}', collectionId));
};

export const updateOverridePrice = (params) => dispatch => {
    return axios.post(api.update_override_price.replace('{collection-id}', params.collectionId), params)
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};


// WEBPACK FOOTER //
// ./src/_thunks/price.thunk.js